import omit from 'lodash/omit'
import gql from 'graphql-tag'
import { GQLLocalAccount } from '~/graphql/__generated__/interfacesLocal'

export const GQL_GTM_ACCOUNT = gql`
  {
    account @client {
      isInternal
      isLogged
      customer {
        gtmCustomerId
        email
      }
    }
  }
`

export const GQL_LOCAL_ACCOUNT = gql`
  {
    account @client {
      id
      isAuth
      isLogged
      customer {
        id
        email
        vipType
        phone
      }
      isLoggedAsEmployee
      isNewCustomer
      consents {
        gdprPanel
        gdprPersonalization
        gdprRemarketing
      }
    }
  }
`

export const GQL_LOCAL_ACCOUNT_MARXY = gql`
  {
    account @client {
      customer {
        id
      }
      consents {
        gdprPersonalization
      }
    }
  }
`

const ACCOUNT_ID = 'MY_ACCOUNT'

export const accountMapper = (data: any) => {
  if (!data.account) {
    return <GQLLocalAccount>{
      __typename: 'Account',
      consents: null,
      customer: null,
      id: ACCOUNT_ID,
      isAuth: false,
      isInternal: false,
      isLogged: false,
      isLoggedAsEmployee: null,
      isNewCustomer: null,
    }
  }

  const consents = data.account?.consents as any
  const customer =
    data.account.customer.length === 0
      ? { id: null }
      : { ...data.account.customer }

  return <GQLLocalAccount>{
    ...omit(data.account, 'consents'),
    __typename: 'Account',
    // NOTE: it is weird but api returns empty array or object
    consents:
      consents.length === 0
        ? null
        : {
            __typename: 'AccountConsents',
            gdprPanel: consents.gdpr_panel || false,
            gdprPersonalization: consents.gdpr_personalization || false,
            gdprRemarketing: consents.gdpr_remarketing || false,
          },
    customer: {
      vipType: null,
      ...customer,
      __typename: 'AccountCustomer',
      yottly: {
        __typename: 'CustomerYottly',
        ...data.account.customer.yottly,
      },
    },
    id: ACCOUNT_ID,
  }
}
